<main>
    <div class="app app-margin">
        <div class="app-container">
    <div class="marT30">
        <div class="row">
            <div class="col-md-8">
                <!--<a [routerLink]="['/']" class="breadcrum">Home</a>-->
                <h4 class="marT20 admin-home" [dir]="textDir">{{dispRole()}} {{'home' | translate}}</h4>
            </div>

        </div>
    </div>


<section [dir]="textDir">
    <div class="row">        
        <div class="column lg-4 md-6 sm-12 card-holder" *ngFor="let item of this.items let i=index let flag = even;">
            <!-- condition to hide not developed modules link temporarily -->
            <ng-container *ngIf="item.title==='Applications & Devices'">
                <div style="opacity: .5;" >
                    <page-link-block  class="unclick" [ngClass]="{'one':flag, 'two':flag, 'three':!flag, 'four':!flag}" [title]=item.title [description]=item.description [imageSrc]="item.imageSrc" [routeLink]="item.routeLink"></page-link-block>
                </div>
            </ng-container>
            <ng-container *ngIf="item.title!=='Applications & Devices'">
                <div >
                    <page-link-block [ngClass]="{'one':flag, 'two':flag, 'three':!flag, 'four':!flag}" [title]=item.title [description]=item.description [imageSrc]="item.imageSrc" [routeLink]="item.routeLink"></page-link-block>
                </div>
            </ng-container>
        </div>

    </div>
   
</section>
    </div>
   </div>
</main>
